export const KIDS_PLAYGAMA_DOMAIN = 'kids.playgama.com'

export function normalizeHost(host: string | undefined) {
    return host?.trim().toLowerCase().replace(/\.$/, '').replace(/:\d+$/, '') || ''
}

export function isKidsHost(host: string | undefined) {
    const normalizedHost = normalizeHost(host)

    return normalizedHost === KIDS_PLAYGAMA_DOMAIN || normalizedHost.endsWith(`.${KIDS_PLAYGAMA_DOMAIN}`)
}
